export const GameStatus = {
  MENU: "menu",
  PLAYING: "playing",
  GAMEOVER: "lost",
  WON: "won",
}

export const GameState = {
  grid: [],
  tiles: '',
  score: 0,
  status: GameStatus.MENU,
}
export const GRID_SIZE = 4
